<router-outlet />
<cap-toast position="top-right" />

<p-confirmDialog #cd appendTo="body">
  <ng-template #footer>
    <cap-button
      styleClass="secondary"
      type="button"
      [label]="(confirmation?.rejectLabel | translate) || ('confirm.no' | translate)"
      (click)="cd.onReject()" />

    <cap-button
      data-test="dialog-confirm-button"
      styleClass="primary"
      type="button"
      [label]="(confirmation?.acceptLabel | translate) || ('confirm.yes' | translate)"
      (click)="cd.onAccept()" />
  </ng-template>
</p-confirmDialog>
